import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-esg-checklist-score',
  templateUrl: './esg-checklist-score.component.html',
})
export class EsgChecklistScoreComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
